import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resolveTopLevelDomain } from './shared/util/deploy-helper';

@Injectable()
export class ApiBaseUrlInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const countryModedUrlRequest = request.clone({
      url: request.url.replace('<current-country>', resolveTopLevelDomain()),
    });

    return next.handle(countryModedUrlRequest);
  }
}
